export default __webpack_public_path__ + "static/media/Putrescent Blade.9c9c3e8e.jpg";